import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';
export var pushUserSymbolsPopup = function () {
    return pushModal(ModalType.USER_SYMBOLS_LEGEND, {
        wrapInModal: false,
    });
};
//# sourceMappingURL=actions.js.map